import {stdnum} from "stdnum";

export function listValidatorsAbbreviationsForCountry(countryCode) {
  const ns = stdnum?.[countryCode];
  if (!ns) return [];

  return Object.values(ns).map((value) => value.abbreviation)
}

function listValidatorsForCountry(countryCode) {
  const ns = stdnum?.[countryCode];
  if (!ns) return [];

  return Object.entries(ns)
    .filter(([, mod]) => mod && typeof mod.validate === "function")
    .map(([key]) => key);
}

function formatEsList(items) {
  // "A" | "A y B" | "A, B o C"
  if (items.length <= 1) return items.join("");
  if (items.length === 2) return `${items[0]} o ${items[1]}`;
  return `${items.slice(0, -1).join(", ")} o ${items.at(-1)}`;
}

export function validateIdForCountry(countryCode, value) {
  const ns = stdnum?.[countryCode];
  const keys = listValidatorsForCountry(countryCode);
  const tried = new Array();

  // Intenta TODOS los validadores disponibles para el país
  for (const key of keys) {
    try {
      const result = ns[key].validate(value);
      if (result?.isValid) {
        return { ok: true, matched: ns[key].abbreviation };
      }
    } catch {
      // si algún validador lanza error, lo tratamos como “no calza”
    }

    tried.push(ns[key].abbreviation);
  }

  return {
    ok: false,
    tried,
    triedStr: formatEsList(tried),
  };
}
